import ticketActions from '../../../../constants/ticketActions';
import t from 'modules/emergencies/components/modals/TicketUpdateTranslations';
import styled from 'styled-components';

const Separator = styled.div`
  border: 1px solid var(--grey200);
  margin: 0.5rem 0;
`;

const NoAvailableActionsContainer = styled.div`
  padding: 16px;
  text-align: center;
`;

const ActionSeparator = () => <Separator />;

const SendMessageText = ({ message }) => (
  <span>
    Send message: <b>{message}</b>
  </span>
);

const LaunchOfferText = () => (
  <span>
    <b>Publish offer</b> to carriers
  </span>
);

const FinishCostNegotiationText = () => (
  <span>
    <b>Finish cost negotiation</b>
  </span>
);

const CloseAuctionsText = () => (
  <span>
    <b>Unpublish offer</b>
  </span>
);

const NoAvailableActions = () => (
  <NoAvailableActionsContainer>
    <i>No actions available for this ticket</i>
  </NoAvailableActionsContainer>
);

const REGISTRY = {
  [ticketActions.ON_THE_WAY]: SendMessageText,
  [ticketActions.DELAYED]: SendMessageText,
  [ticketActions.DELIVERED]: SendMessageText,
  [ticketActions.PICKUP]: SendMessageText,
  [ticketActions.SEPARATOR]: ActionSeparator,
  [ticketActions.LAUNCH_OFFER]: LaunchOfferText,
  [ticketActions.FINISH_COST_NEGOTIATION]: FinishCostNegotiationText,
  [ticketActions.CLOSE_AUCTIONS]: CloseAuctionsText,
  [ticketActions.NO_AVAILABLE_ACTIONS]: NoAvailableActions,
};

const ActionComponent = (action) => {
  const Component = REGISTRY[action.type];

  return <Component message={t[action.type]} />;
};

export default ActionComponent;
